"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _manager, _session, _conference, _notificationSentForParticipantsIds, _indicatorsInterval, _isJoining, _cachedTracks, _leaveConferenceOnBeforeUnload, _spatialAudioManager;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConferenceService = void 0;
const debug_1 = __importDefault(require("debug"));
const Service_1 = require("../Service");
const events_1 = require("../../events");
const VoxeetApi_1 = __importDefault(require("../../api/VoxeetApi"));
const ConferenceManager_1 = __importDefault(require("./ConferenceManager"));
const Utils_1 = require("../../lib/Utils");
const Helpers_1 = require("../../models/Helpers");
const Participant_1 = require("../../models/Participant");
const logging_1 = __importDefault(require("../../lib/logging"));
const MediaStream_1 = require("../../models/MediaStream");
const Conference_1 = __importStar(require("../../models/Conference"));
const ConferenceParameters_1 = __importDefault(require("../../models/ConferenceParameters"));
const ConferenceUtils_1 = __importDefault(require("../../utils/ConferenceUtils"));
const Exceptions_1 = require("../../lib/Exceptions");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const SpatialAudio_1 = require("../../models/SpatialAudio");
const SpatialAudioManager_1 = require("../../lib/SpatialAudioManager");
/**
 * @ignore
 */
const debug = debug_1.default('vxt:confservice');
/**
 * @ignore
 */
var ConferenceServiceEvents;
(function (ConferenceServiceEvents) {
    ConferenceServiceEvents["Created"] = "created";
    ConferenceServiceEvents["Joined"] = "joined";
    ConferenceServiceEvents["Left"] = "left";
    ConferenceServiceEvents["Ended"] = "ended";
    ConferenceServiceEvents["Destroyed"] = "destroyed";
    ConferenceServiceEvents["Stats"] = "stats";
    ConferenceServiceEvents["Switched"] = "switched";
    ConferenceServiceEvents["Error"] = "error";
    ConferenceServiceEvents["QualityIndicators"] = "qualityIndicators";
    ConferenceServiceEvents["ParticipantAdded"] = "participantAdded";
    ConferenceServiceEvents["ParticipantUpdated"] = "participantUpdated";
    ConferenceServiceEvents["ParticipantLeft"] = "participantLeft";
    ConferenceServiceEvents["AutoplayBlocked"] = "autoplayBlocked";
    ConferenceServiceEvents["StreamAdded"] = "streamAdded";
    ConferenceServiceEvents["StreamUpdated"] = "streamUpdated";
    ConferenceServiceEvents["StreamRemoved"] = "streamRemoved";
    ConferenceServiceEvents["PermissionsUpdated"] = "permissionsUpdated";
})(ConferenceServiceEvents || (ConferenceServiceEvents = {}));
/**
 * @ignore
 */
const INDICATORS_INTERVAL = 5000;
/**
 * The ConferenceService allows the application to manage the conference life-cycle and interact with the conference.
 *
 * **The ConferenceService introduces APIs that allow the application to:**
 *
 * - [Create](#create) a conference
 * - [Fetch](#fetch) the Conference object required to join a conference
 * - [Join](#join) a conference with permission to share media or as a [listener](#listen)
 * - [Set](#videoforwarding) the maximum number of video streams a participant would like to receive.
 * - Configure the quality of the received [Simulcast](#simulcast) streams
 * - Create a [demo](#demo) conference and join it
 * - [Start](#startaudio) and [stop](#stopaudio) audio transmission
 * - [Start](#startvideo) and [stop](#stopvideo) video transmission
 * - [Start](#startscreenshare) and [stop](#stopscreenshare) sharing the screen
 * - Control the [mute](#mute) state of the conference participants
 * - Get the current [mute state](#ismuted) of the local participant
 * - Check the [audio level](#audiolevel) of a specific participant
 * - Get the [participants'](#participants) list
 * - Get the [speaking status](#isspeaking) of a selected participant
 * - [Check](#localstats) the WebRTC statistics
 * - [Leave](#leave) the conference
 * - [Replay](#replay) the previously recorded conference
 * - Enable and disable [audio processing](#audioprocessing) for the local participant
 * - [Kick](#kick) a participant from a conference
 * - [Update](#updatepermissions) the participant's permissions
 * - [Ask](#current) about conference details
 * - [Set](#setspatialposition) a participant's position to enable the spatial audio experience during a Dolby Voice conference
 * - [Configure](#setspatialenvironment) a spatial environment of the application for the spatial audio feature
 * - [Set](#setspatialdirection) the direction a participant is facing during a conference with enabled spatial audio
 *
 * **The ConferenceService introduces events that inform the application that:**
 *
 * - The participant has [joined](#joined) a conference or has [left](#left) it
 * - A connected participant [joins](#switched) a conference using another device and the same `ExternalId`
 * - A conference participant has [joined](#participantadded) a conference or [changed](#participantupdated) status
 * - A stream is [added](#streamadded), [updated](#streamupdated), or [removed](#streamremoved)
 * - The replayed conference has [ended](#ended)
 * - An [error](#error) has occurred
 * - Conference permissions have been [updated](#permissionsupdated)
 *
 * Additionally, every 5 seconds the application emits the [qualityIndicators](#qualityindicators) event informing about the audio and video quality of the remote participants.
 *
 * If a browser blocks the received audio streams due to auto-play policy, the application can call the [autoplayBlocked](#autoplayblocked) and [playBlockedAudio](#playblockedaudio) APIs to enable playing the received audio.
 *
 * ---
 * @noInheritDoc
 */
let ConferenceService = class ConferenceService extends Service_1.BaseConferenceService {
    /**
     * @ignore
     * @param sdk
     * @param session
     */
    constructor(sdk, session) {
        super(sdk);
        _manager.set(this, void 0);
        _session.set(this, void 0);
        _conference.set(this, void 0);
        _notificationSentForParticipantsIds.set(this, []);
        _indicatorsInterval.set(this, void 0);
        _isJoining.set(this, void 0);
        _cachedTracks.set(this, new Map());
        _leaveConferenceOnBeforeUnload.set(this, true);
        _spatialAudioManager.set(this, void 0);
        __classPrivateFieldSet(this, _session, session);
        __classPrivateFieldSet(this, _manager, new ConferenceManager_1.default(this));
        __classPrivateFieldSet(this, _isJoining, false);
    }
    /**
     * Creates a conference with [ConferenceOptions](model/conferenceoptions).
     *
     * @param options - The conference options.
     * @returns
     */
    create(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const newOptions = Helpers_1.makeConferenceOptions(options);
            const res = yield VoxeetApi_1.default.conferences.create({
                data: newOptions,
            });
            if (res.data.ownerToken) {
                VoxeetApi_1.default.setConferenceTokens(res.data.conferenceId, res.data.ownerToken);
            }
            this.onConferenceCreated();
            return Conference_1.default.fromCreateData(res.data);
        });
    }
    /**
     * Provides a Conference object that allows joining a conference. For more information about using the fetch method, see the [Conferencing](doc:conferencing#creating-and-joining-conferences-using-the-conference-id) document.
     *
     * @param conferenceId - The conference ID.
     * @return
     */
    fetch(conferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const conference = new Conference_1.default(conferenceId);
            const token = VoxeetApi_1.default.getConferenceToken(conferenceId);
            if (token) {
                conference.permissions = this.getPermissionsFromToken(token);
            }
            return conference;
        });
    }
    /**
     * Creates and joins a demo conference.
     */
    demo() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield VoxeetApi_1.default.conferences.getDemo();
            return yield this._join(Conference_1.default.fromCreateData(res.data), {
                conference: { isDemo: true },
            });
        });
    }
    /**
     * Replays a previously recorded conference. For more information, see the [Recording mechanisms](doc:guides-recording-mechanisms) article.
     *
     * See also: [join](#join), [listen](#listen)
     *
     * @param conference - The conference object.
     * @param replayOptions - The replay options.
     * @param mixingOptions - The model that notifies the server that a participant who replays the conference is a special participant called [Mixer](doc:guides-recording-mechanisms#mixer).
     *
     * @returns
     */
    replay(conference, replayOptions = { offset: 0 }, mixingOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (replayOptions.conferenceAccessToken) {
                VoxeetApi_1.default.currentConferenceToken = replayOptions.conferenceAccessToken;
            }
            else {
                VoxeetApi_1.default.setCurrentConferenceToken(conference.id);
            }
            let res = yield VoxeetApi_1.default.conferences.replay({
                conferenceId: conference.id,
                data: { offset: replayOptions.offset },
            });
            if (res.data.ownerToken) {
                VoxeetApi_1.default.setConferenceTokens(res.data.conferenceId, res.data.ownerToken);
            }
            return yield this._join(Conference_1.default.fromCreateData(res.data), { mixing: mixingOptions }, true);
        });
    }
    /**
     * Joins a conference as a listener. You can choose to either [join](#join), [replay](#replay), or [listen](#listen) to a conference. The `listen` method connects to the conference in the receiving only mode which does not allow transmitting video or audio.
     *
     * **Note**: Conference events from other listeners are not available for listeners. Only users will receive conference events from other listeners.
     *
     * See also: [join](#join), [replay](#replay)
     *
     * @param conference - The conference object.
     * @param options - The additional options for the joining listener.
     */
    listen(conference, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const overriddenOptions = options ? Object.assign(Object.assign({}, options), { constraints: { audio: false, video: false } }) : { constraints: { audio: false, video: false } };
            return yield this._join(conference, overriddenOptions, true);
        });
    }
    /**
     * Joins the conference.
     *
     * **Note**: Participants who use Apple Mac OS and the Safari browser to join conferences may experience problems with distorted audio. To solve the problem, we recommend using the latest version of Safari.
     *
     * **Note**: Due to a known Firefox issue, a user who has never permitted Firefox to use a microphone and camera cannot join a conference as a listener. If you want to join a conference as a listener using the Firefox browser, make sure that Firefox has permission to use your camera and microphone. To check the permissions, follow these steps:
     *
     * **1.** Select the lock icon in the address bar. </br>
     * **2.** Select the right arrow placed next to `Connection Secure`. </br>
     * **3.** Select `More information`. </br>
     * **4.** Go to the `Permissions` tab. </br>
     * **5.** Look for the `Use the camera` and `Use the microphone` permission and select the `Allow` option.
     *
     * See also: [listen](#listen), [replay](#replay)
     *
     * @param conference - The conference object.
     * @param options - The additional options for the joining participant.
     * @return {Promise<Conference|Error>}
     *
     * @example
     *```javascript
     * // For example
     * const constraints = {
     *   audio: true,
     *   video: {
     *     width: {
     *       min: "320",
     *       max: "1280"
     *     },
     *     height: {
     *       min: "240",
     *       max: "720"
     *     }
     *   }
     * };
     *
     * // A simplest example of constraints would be:
     * const constraints = {audio: true, video: true};
     *
     * VoxeetSDK.conference.join(conference, {constraints: constraints})
     *   .then((info) => {
     *   })
     *   .catch((error) => {
     *   });
     * ```
     */
    join(conference, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _isJoining))
                return this._join(conference, options, false);
            else
                throw new Error('Already joining a conference');
        });
    }
    /* istanbul ignore next */
    _join(conference, options, listen = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let vfsDefaultValue = Helpers_1.isMobile() ? Utils_1.VIDEO_FORWARDING_MOBILE_MAX_VALUE : Utils_1.VIDEO_FORWARDING_DESKTOP_MAX_VALUE;
                if (options.hasOwnProperty('maxVideoForwarding') &&
                    options.maxVideoForwarding !== undefined &&
                    (typeof options.maxVideoForwarding !== 'number' ||
                        !Number.isInteger(options.maxVideoForwarding) ||
                        options.maxVideoForwarding < 0 ||
                        options.maxVideoForwarding > vfsDefaultValue)) {
                    throw new Exceptions_1.VideoForwardingError(`The number of streams provided in the videoForwarding API is incorrect, valid values range from 0 to ${vfsDefaultValue}.`);
                }
                __classPrivateFieldSet(this, _isJoining, true);
                if (options.leaveConferenceOnBeforeUnload !== undefined) {
                    __classPrivateFieldSet(this, _leaveConferenceOnBeforeUnload, options.leaveConferenceOnBeforeUnload);
                }
                const newOptions = {
                    constraints: Utils_1.buildConstraints({ predefinedConstraints: options.constraints, mixingEnabled: !!options.mixing }),
                    mixing: Helpers_1.makeMixingOptions(conference.id, options.mixing),
                    simulcast: Helpers_1.makeSimulcastOption(options.simulcast),
                    preferSendMono: 'preferSendMono' in options ? options.preferSendMono : true,
                    preferRecvMono: 'preferRecvMono' in options ? options.preferRecvMono : false,
                    maxVideoForwarding: options.maxVideoForwarding,
                    forwardingStrategy: true,
                    dvwc: options.dvwc || false,
                    videoFilter: options.videoFilter,
                    videoFilterOptions: Object.assign({}, options.videoFilterOptions),
                    spatialAudio: options.spatialAudio,
                };
                if ('audioTweaks' in options) {
                    Object.defineProperty(newOptions, 'audioTweaks', { value: options.audioTweaks });
                }
                const processCb = null; //options.processCb || null;
                logging_1.default.setConferenceId(conference.id);
                if (options.spatialAudio) {
                    __classPrivateFieldSet(this, _spatialAudioManager, new SpatialAudioManager_1.SpatialAudioManager(conference.id, __classPrivateFieldGet(this, _session).participant.id));
                }
                yield this.leave();
                __classPrivateFieldSet(this, _conference, conference);
                // use the conferenceToken related to the conferenceId joined and clear the collection of CATs
                if (options.conferenceAccessToken) {
                    VoxeetApi_1.default.currentConferenceToken = options.conferenceAccessToken;
                }
                else {
                    VoxeetApi_1.default.setCurrentConferenceToken(conference.id);
                }
                // update permissions from the current conference token
                let conferenceToken = VoxeetApi_1.default.getCurrentConferenceToken();
                if (conferenceToken) {
                    this.current.permissions = this.getPermissionsFromToken(conferenceToken);
                }
                const { metadata, conferenceAlias } = yield __classPrivateFieldGet(this, _manager).init(__classPrivateFieldGet(this, _session).participant, conference.id, newOptions, processCb, listen, conference);
                conference.params = ConferenceParameters_1.default.fromJoinData(metadata);
                conference.status = Conference_1.ConferenceStatus.Joined;
                if (conferenceAlias && typeof conferenceAlias === 'string') {
                    conference.alias = conferenceAlias;
                }
                __classPrivateFieldSet(this, _isJoining, false);
                return __classPrivateFieldGet(this, _conference);
            }
            catch (err) {
                __classPrivateFieldSet(this, _isJoining, false);
                throw err;
            }
        });
    }
    /**
     * Updates the participant's conference permissions. If a participant does not have permission to perform a specific action, this action is not available for this participant during a conference, and the participant receives [InsufficientPermissionsError](doc:js-client-sdk-model-conferenceerror). If a participant started a specific action and then lost permission to perform this action, the SDK stops the blocked action. For example, if a participant started sharing a screen and received the updated permissions that do not allow him to share a screen, the SDK stops the screen sharing session and the participant cannot start sharing the screen again.
     *
     * ```javascript
     * VoxeetSDK.conference.updatePermissions(participantPermissions: Array<ParticipantPermissions>)
     * ```
     *
     * @param participantPermissions - The updated participant's permissions.
     */
    updatePermissions(participantPermissions) {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _manager).updatePermissions(participantPermissions);
        });
    }
    /**
     * Leaves the conference.
     * @param options
     */
    leave(options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const leaveRoom = options.leaveRoom || true;
            const reason = options.reason || 'hangUp';
            const keepAlive = options.keepAlive || false;
            if (this._conferenceId !== null && __classPrivateFieldGet(this, _conference) && __classPrivateFieldGet(this, _manager) && !__classPrivateFieldGet(this, _manager).isLeaving) {
                const dolbyVoice = (_a = __classPrivateFieldGet(this, _conference).params) === null || _a === void 0 ? void 0 : _a.dolbyVoice;
                if (dolbyVoice) {
                    // fake stream removed for remote participant that are audio-only
                    __classPrivateFieldGet(this, _manager).participants.forEach((participant, key) => {
                        if (participant.id !== __classPrivateFieldGet(this, _session).participant.id) {
                            const cameraMedia = participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.Camera);
                            const screenshareMedia = participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.ScreenShare);
                            const mediaVideoTrack = cameraMedia.length > 0 && cameraMedia[0].getVideoTracks()[0];
                            const isScreenShare = screenshareMedia.length > 0;
                            if (isScreenShare) {
                                this.emit(ConferenceServiceEvents.StreamRemoved, participant, screenshareMedia[0]);
                            }
                            if (participant.audioTransmitting && !mediaVideoTrack) {
                                this.emit(ConferenceServiceEvents.StreamRemoved, participant, new MediaStream_1.DvcsMediaStream(new MediaStream()));
                            }
                        }
                    });
                }
                yield __classPrivateFieldGet(this, _manager).leave({ leaveRoom, reason, keepAlive });
                __classPrivateFieldGet(this, _manager).clear();
                __classPrivateFieldSet(this, _conference, null);
            }
        });
    }
    /**
     * Allows a specific participant to play audio that is blocked by the browser's auto-play policy.
     */
    playBlockedAudio() {
        __classPrivateFieldGet(this, _manager).rtc.playBlockedAudio();
    }
    /**
     * Stops playing the specified remote participants' audio to the local participant or stops playing the local participant's audio to the conference. The mute method does not notify the server to stop audio stream transmission. To stop sending an audio stream to the server or to stop receiving an audio stream from the server, use the [stopAudio](#stopaudio) method.
     *
     * The mute method depends on the Dolby Voice usage:
     *
     * - In conferences where Dolby Voice is not enabled, conference participants can mute themselves or remote participants.
     * - In conferences where Dolby Voice is enabled, please use [stopAudio](#stopAudio) to mute and [startAudio](#startAudio) to unmute remote participants.
     *
     * **Note**: In SDK 2.4 and prior releases, if a conference participant calls the mute method, empty frames are sent to the other participants. Due to a Safari issue, participants who join a conference using Safari and start receiving the empty frames can experience a Safari crash. Due to a different API implementation in SDK 3.0, this problem does not occur during Dolby Voice conferences.
     *
     * @param participant - The local or remote conference participant.
     * @param isMuted - The mute state, `true` indicates that a participant is muted, `false` indicates that a participant is not muted.
     */
    mute(participant, isMuted) {
        if (__classPrivateFieldGet(this, _conference) && __classPrivateFieldGet(this, _conference).params.dolbyVoice && __classPrivateFieldGet(this, _session).participant.id !== participant.id) {
            throw new Exceptions_1.UnsupportedError();
        }
        if (this.current.permissions.has(Conference_1.ConferencePermission.SendAudio)) {
            this.manager.setLocalStateMute(isMuted);
            this.manager.rtc.mutePeer(participant.id, isMuted);
        }
        else {
            throw Exceptions_1.InsufficientPermissionsError();
        }
    }
    /**
     * Toggles mute on a participant.
     * @param participant
     * @return Mute state of the participant
     * @ignore
     */
    toggleMute(participant) {
        if (__classPrivateFieldGet(this, _conference) && __classPrivateFieldGet(this, _conference).params.dolbyVoice && __classPrivateFieldGet(this, _session).participant.id !== participant.id) {
            throw new Exceptions_1.UnsupportedError();
        }
        if (this.current.permissions.has(Conference_1.ConferencePermission.SendAudio)) {
            __classPrivateFieldGet(this, _manager).setLocalStateMute(!__classPrivateFieldGet(this, _manager).localStateMute);
            return __classPrivateFieldGet(this, _manager).rtc.toggleMute(participant.id);
        }
        else {
            throw Exceptions_1.InsufficientPermissionsError();
        }
    }
    /**
     * Gets the current mute state of the local participant.
     *
     * **Note**: This API is no longer supported for remote participants.
     *
     * @return
     */
    isMuted() {
        return __classPrivateFieldGet(this, _manager).rtc.isOwnMuted();
    }
    /**
     * Gets the participant's audio level. The possible values of the audio level are in range from 0.0 to 1.0 point.
     *
     * **Note**: This API is no longer supported for remote participants when the client connects to a Dolby Voice conference.
     *
     * @param participant - The conference participant.
     * @param callback - The callback that retrieves the audio level.
     */
    audioLevel(participant, callback) {
        if (__classPrivateFieldGet(this, _conference) && __classPrivateFieldGet(this, _conference).params.dolbyVoice && __classPrivateFieldGet(this, _session).participant.id !== participant.id) {
            // let participantDetails = this.participants.get(participant.id);
            // callback(participantDetails.level);
            throw new Exceptions_1.UnsupportedError();
        }
        return __classPrivateFieldGet(this, _manager).rtc.getLevel(participant.id, callback);
    }
    /**
     * Gets the participant's current speaking status for an active talker indicator.
     * @param participant - The conference participant.
     * @param callback - The callback that accepts a boolean value indicating the participant's current speaking status. If the participant actively uses a microphone, the callback marks the participant as an active speaker.
     *
     */
    isSpeaking(participant, callback) {
        if (__classPrivateFieldGet(this, _conference)) {
            const currentParticipant = this.participants.get(participant.id);
            if ((__classPrivateFieldGet(this, _conference).params.dolbyVoice && !__classPrivateFieldGet(this, _manager).isElectron()) ||
                (__classPrivateFieldGet(this, _manager).isElectron() && currentParticipant === __classPrivateFieldGet(this, _session).participant) // temporary fix while electron getLevel is not working for local participant
            ) {
                callback(!!(currentParticipant && currentParticipant.active));
            }
            else {
                return __classPrivateFieldGet(this, _manager).rtc.isSpeaking(participant.id, callback);
            }
        }
    }
    /**
     * @ignore
     * Advanced Users only.
     * @param stream
     * @param type
     */
    startStream(stream, type = MediaStream_1.MediaStreamType.Custom) {
        return __classPrivateFieldGet(this, _manager).startStream(stream, type);
    }
    /**
     * @ignore
     * @param stream
     */
    stopStream(stream) { }
    /**
     * Notifies the server to either start sending the local participant's video stream to the conference or start sending a remote participant's video stream to the local participant. The startVideo method does not control the remote participant's video stream; if a remote participant does not transmit any video stream, the local participant cannot change it using the startVideo method.
     *
     * @param participant - The participant who will receive the video stream, either remote or local.
     * @param constraints - The [WebRTC video constraints](https://www.w3.org/TR/mediacapture-streams/#dom-mediastreamconstraints-video).
     *
     * @return {Promise<Error>}
     *
     * @example
     *```javascript
     * const videoConstraints = {
     *     width: {
     *         min: "320",
     *         max: "1280"
     *     },
     *     height: {
     *         min: "240",
     *         max: "720"
     *     }
     * };
     *
     * VoxeetSDK.conference.startVideo(VoxeetSDK.session.participant, videoConstraints).then(() => { });
     * ```
     */
    startVideo(participant, constraints) {
        let newConstraints = Utils_1.makeVideoConstraints(constraints);
        return __classPrivateFieldGet(this, _manager).startVideoForPeer(participant.id, newConstraints);
    }
    /**
     * Notifies the server to either stop sending the local participant's video stream to the conference or stop sending a remote participant's video stream to the local participant.
     * @param participant - The participant who will stop receiving the video stream.
     * @return {Promise<Error>}
     */
    stopVideo(participant) {
        return __classPrivateFieldGet(this, _manager).stopVideoForPeer(participant.id);
    }
    /**
     * Sets the maximum number of video streams that may be transmitted to the local participant. This method also allows using a pin option to prioritize the specific participant's video streams and display their videos even when these participants do not talk. For more information, see the [Video Forwarding](doc:guides-video-forwarding) article.
     * @param max - The maximum number of video streams that may be transmitted to the local participant. The valid parameter's values are between 0 and 25 for desktop browsers and between 0 and 4 for mobile browsers. In the case of providing a value smaller than 0 or greater than the valid values, SDK triggers the [VideoForwardingError](doc:js-client-sdk-model-videoforwardingerror). If the parameter value is not specified, the SDK automatically sets the maximum possible value: 25 for desktop browsers and 4 for mobile browsers.
     * @param participants - The list of the prioritized participants. This parameter allows using a pin option to prioritize specific participant's video streams and display their videos even when these participants do not talk.
     * @return {Promise<Error>}
     */
    videoForwarding(max, participants) {
        return __awaiter(this, void 0, void 0, function* () {
            // Activate video forwarding strategy
            let vfsDefaultValue = Helpers_1.isMobile() ? Utils_1.VIDEO_FORWARDING_MOBILE_MAX_VALUE : Utils_1.VIDEO_FORWARDING_DESKTOP_MAX_VALUE;
            if (typeof max !== 'number' || !Number.isInteger(max) || max < 0 || max > vfsDefaultValue) {
                throw new Exceptions_1.VideoForwardingError(`The number of streams provided in the videoForwarding API is incorrect, valid values range from 0 to ` + vfsDefaultValue + `.`);
            }
            return __classPrivateFieldGet(this, _manager).videoForwarding(max, participants);
        });
    }
    /**
     * Enables and disables audio processing for the local participant.
     * @param participant - The conference participant.
     * @param options - The audio processing information.
     * @return {Promise<Error>}
     */
    audioProcessing(participant, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _manager).isDvwc() || __classPrivateFieldGet(this, _manager).isElectron()) {
                yield __classPrivateFieldGet(this, _manager).rtc.setTransparentMode(!options.send.audioProcessing);
            }
            else {
                const audioProcessingNewOptions = Helpers_1.makeAudioProcessingOptions(options);
                const res = yield VoxeetApi_1.default.conferences.audioProcessing({
                    conferenceId: this._conferenceId,
                    peerId: participant.id,
                    data: audioProcessingNewOptions,
                });
            }
        });
    }
    /**
     * Starts audio transmission between the local client and a conference. The startAudio method impacts only the audio streams that the local participant sends and receives; the method does not impact the audio transmission between remote participants and a conference and does not allow the local participant to force sending remote participants’ streams to the conference or to the local participant. Depending on the specified participant in the `participant` parameter, the startAudio method starts the proper audio transmission:
     *
     * - When the specified participant is the local participant, startAudio ensures sending local participant’s audio from the local client to the conference.
     *
     * - When the specified participant is a remote participant, startAudio ensures sending remote participant’s audio from the conference to the local client. This allows the local participant to unmute remote participants who are locally muted through the [stopAudio](#stopaudio) method.
     *
     * The startAudio method in Dolby Voice conferences is not available for listeners and triggers [UnsupportedError](doc:js-client-sdk-model-unsupportederror).
     *
     * The SDK automatically manages audio rendering, which means that the application does not need to implement its own <audio> element. The application can use the [selectAudioInput](doc:js-client-sdk-mediadeviceservice#selectaudioinput) and [selectAudioOutput](doc:js-client-sdk-mediadeviceservice#selectaudiooutput) methods to select the proper audio input and output devices.
     *
     * The startAudio method requires a few seconds to become effective.
     *
     * @param participant - The selected participant. If you wish to transmit the local participant's audio stream to the conference, provide the local participant's object. If you wish to receive the specific remote participants' audio streams, provide these remote participants' objects.
     *
     * @return {Promise<Error>}
     */
    startAudio(participant) {
        if (__classPrivateFieldGet(this, _session).participant.id === participant.id && [Participant_1.ParticipantType.LISTENER, Participant_1.ParticipantType.MIXER].includes(__classPrivateFieldGet(this, _session).participant.type)) {
            throw new Exceptions_1.UnsupportedError();
        }
        if (__classPrivateFieldGet(this, _session).participant.id !== participant.id &&
            this.current &&
            this.current.params.dolbyVoice &&
            [Participant_1.ParticipantType.LISTENER].includes(__classPrivateFieldGet(this, _session).participant.type)) {
            throw new Exceptions_1.UnsupportedError();
        }
        return __classPrivateFieldGet(this, _manager).startAudioForPeer(participant.id).then(() => {
            if (__classPrivateFieldGet(this, _session).participant.id !== participant.id) {
                let audioTransmitting = participant.audioTransmitting;
                participant.updateAudioReceivingStopped(false);
                this.onParticipantUpdatedHandleStreams(participant, audioTransmitting, participant.audioTransmitting);
            }
        });
    }
    /**
     * Stops audio transmission between the local client and a conference. The stopAudio method impacts only the audio streams that the local participant sends and receives; the method does not impact the audio transmission between remote participants and a conference and does not allow the local participant to stop sending remote participants’ streams to the conference. Depending on the specified participant in the `participant` parameter, the stopAudio method stops the proper audio transmission:
     *
     * - When the specified participant is the local participant, stopAudio stops sending local participant’s audio from the local client to the conference.
     *
     * - When the specified participant is a remote participant, stopAudio stops sending remote participant’s audio from the conference to the local client. This allows the local participant to locally mute remote participants.
     *
     * The stopAudio method in Dolby Voice conferences is not available for listeners and triggers [UnsupportedError](doc:js-client-sdk-model-unsupportederror).
     *
     * Leaving a conference resets the stopAudio settings. Participants who rejoin a conference need to provide the desired stopAudio parameters and call the stopAudio method once again.
     *
     * The stopAudio method requires a few seconds to become effective.
     *
     * @param participant - The selected participant. If you wish to not transmit the local participant's audio stream to the conference, provide the local participant's object. If you wish to not receive the specific remote participants' audio streams, provide these remote participants' objects.
     * @return {Promise<Error>}
     */
    stopAudio(participant) {
        if (__classPrivateFieldGet(this, _session).participant.id === participant.id && [Participant_1.ParticipantType.LISTENER, Participant_1.ParticipantType.MIXER].includes(__classPrivateFieldGet(this, _session).participant.type)) {
            throw new Exceptions_1.UnsupportedError();
        }
        if (__classPrivateFieldGet(this, _session).participant.id !== participant.id &&
            this.current &&
            this.current.params.dolbyVoice &&
            [Participant_1.ParticipantType.LISTENER].includes(__classPrivateFieldGet(this, _session).participant.type)) {
            throw new Exceptions_1.UnsupportedError();
        }
        return __classPrivateFieldGet(this, _manager).stopAudioForPeer(participant.id).then(() => {
            if (__classPrivateFieldGet(this, _session).participant.id !== participant.id) {
                let audioTransmitting = participant.audioTransmitting;
                participant.updateAudioReceivingStopped(true);
                this.onParticipantUpdatedHandleStreams(participant, audioTransmitting, participant.audioTransmitting);
            }
        });
    }
    /**
     * Starts a screen sharing session.
     * @return {Promise<Error>}
     *
     * @example
     *```javascript
     * VoxeetSDK.conference.startScreenShare()
     *   .then(() => {
     *
     *   })
     *   .catch(e => {
     *
     *   });
     * ````
     */
    startScreenShare(sourceId) {
        return __classPrivateFieldGet(this, _manager).startScreenShare(sourceId || null);
    }
    /**
     * Stops the screen-sharing session.
     * @return {Promise<Error>}
     */
    stopScreenShare() {
        return __classPrivateFieldGet(this, _manager).stopScreenShare();
    }
    /**
     * Provides [standard WebRTC statistics](https://www.w3.org/TR/webrtc-stats/#dom-rtcstatstype) for the application. Based on the WebRTC statistics, the SDK computes [audio and video statistics](doc:js-client-sdk-model-qualityindicator).
     * @return {Promise<Statistics>}
     */
    localStats() {
        return __classPrivateFieldGet(this, _manager).rtc.getRtpStats();
    }
    /**
     * Configures the quality of the received Simulcast streams.
     *
     * @param requested - An array that includes the streams qualities for specific conference participants.
     */
    simulcast(requested) {
        return VoxeetApi_1.default.conferences.simulcast({
            conferenceId: this._conferenceId,
            data: { requested: requested },
        });
    }
    /**
     * Allows the conference owner, or a participant with adequate permissions, to kick another participant from the conference by revoking the conference access token. The kicked participant cannot join the conference again.
     *
     * ```javascript
     * VoxeetSDK.conference.kick(participant: Participant)
     * ```
     *
     * @param participant - The participant who needs to be kicked from the conference.
     */
    kick(participant) {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _manager).kick(participant.id);
        });
    }
    /**
     * Generates state dump for purpose of failure investigation. State dump is in ZIP format.
     * @ignore
     */
    createStateDump() {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _manager).rtc.createStateDump();
        });
    }
    /**
     * @param returns an audio logging length
     * @ignore
     */
    getStateDumpConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _manager).rtc.getStateDumpConfiguration();
        });
    }
    /**
     * @param audioLoggingLength - Length in seconds of internal audio logging.
     * @ignore
     */
    configureStateDump(audioLoggingLength) {
        return __awaiter(this, void 0, void 0, function* () {
            return __classPrivateFieldGet(this, _manager).rtc.configureStateDump(audioLoggingLength);
        });
    }
    /**
     * > 🚀Pre-release
     * >
     * > This API is a part of the [Pre-release program](doc:overview-pilot-and-pre-release-programs), as a Closed Beta.
     *
     * Sets a participant's position in space to enable the spatial audio experience during a Dolby Voice conference. This method is available only for participants who joined the conference with the [spatialAudio](doc:js-client-sdk-model-joinoptions#spatialaudio) parameter enabled. Otherwise, SDK triggers [UnsupportedError](doc:js-client-sdk-model-unsupportederror). Depending on the specified participant in the `participant` parameter, the setSpatialPosition method impacts the location from which audio is heard or from which audio is rendered:
     *
     * - When the specified participant is the local participant, setSpatialPosition sets a location from which the local participant listens to a conference. If the local participant does not have an established location, the participant hears audio from the default location (0, 0, 0).
     *
     * - When the specified participant is a remote participant, setSpatialPosition ensures the remote participant's audio is rendered from the specified position in space. If the remote participant does not have an established location, the participant does not have a default position and will remain muted until a position is specified.
     *
     * For example, if a local participant Eric, who does not have a set direction, calls setSpatialPosition(VoxeetSDK.session.participant, {x:3,y:0,z:0}), Eric hears audio from the position (3,0,0). If Eric also calls setSpatialPosition(Sophia, {x:7,y:1,z:2}), he hears Sophia from the position (7,1,2). In this case, Eric hears Sophia 4 meters to the right, 1 meter above, and 2 meters in front. The following graphic presents the participants' locations:
     *
     * <--A graphic placeholder-->
     *
     * If sending the updated positions to the server fails, the SDK generates the ConferenceService event error that includes [SpatialAudioError](doc:js-client-sdk-model-spatialaudioerror).
     *
     * @param participant - The selected participant. Using the local participant sets the location from which the participant will hear a conference. Using a remote participant sets the position from which the participant's audio will be rendered.
     * @param position - The participants' audio location.
     */
    setSpatialPosition(participant, position) {
        if (!__classPrivateFieldGet(this, _conference) || !__classPrivateFieldGet(this, _conference).params.dolbyVoice || !__classPrivateFieldGet(this, _spatialAudioManager)) {
            throw new Exceptions_1.UnsupportedError();
        }
        if (__classPrivateFieldGet(this, _session).participant.id !== participant.id) {
            __classPrivateFieldGet(this, _spatialAudioManager).setRemotePosition(participant, position);
        }
        else {
            __classPrivateFieldGet(this, _spatialAudioManager).setLocalPosition(position);
        }
    }
    /**
     * > 🚀Pre-release
     * >
     * > This API is a part of the [Pre-release program](doc:overview-pilot-and-pre-release-programs), as a Closed Beta.
     *
     * Sets the direction a participant is facing in space. This method is available only for participants who joined the conference with the [spatialAudio](doc:js-client-sdk-model-joinoptions#spatialaudio) parameter enabled. Otherwise, SDK triggers [UnsupportedError](doc:js-client-sdk-model-unsupportederror).
     *
     * Currently, this method is only supported for the local participant. The method changes the direction the local participant is facing. When the specified participant is a remote participant, SDK triggers [UnsupportedError](doc:js-client-sdk-model-unsupportederror).
     *
     * If the local participant hears audio from the position (0,0,0) facing down the Z-axis and locates a remote participant in the position (1,0,1), the local participant hears the remote participant from their front-right. If the local participant chooses to change the direction they are facing and rotate +90 degrees about the Y-axis, then instead of hearing the speaker from the front-right position, they hear the speaker from the front-left position. The following graphic presents this example:
     *
     * <--A graphic placeholder-->
     *
     * For more information, see the [SpatialDirection](doc:js-client-sdk-model-spatialdirection) model.
     *
     * If sending the updated positions to the server fails, the SDK generates the ConferenceService event error that includes [SpatialAudioError](doc:js-client-sdk-model-spatialaudioerror).
     *
     * @param participant - The selected participant. Using the local participant sets the location from which the participant will hear a conference. Using a remote participant sets the position from which the participant's audio will be rendered.
     * @param direction - The direction the participant is facing in space.
     *
     */
    setSpatialDirection(participant, direction) {
        if (!__classPrivateFieldGet(this, _conference) || !__classPrivateFieldGet(this, _conference).params.dolbyVoice || !__classPrivateFieldGet(this, _spatialAudioManager)) {
            throw new Exceptions_1.UnsupportedError();
        }
        if (__classPrivateFieldGet(this, _session).participant.id !== participant.id) {
            throw new Exceptions_1.UnsupportedError();
        }
        else {
            __classPrivateFieldGet(this, _spatialAudioManager).setLocalDirection(direction);
        }
    }
    /**
     * > 🚀Pre-release
     * >
     * > This API is a part of the [Pre-release program](doc:overview-pilot-and-pre-release-programs), as a Closed Beta.
     *
     * Configures a spatial environment of an application, so the audio renderer understands which directions the application considers forward, up, and right and which units it uses for distance.
     *
     * This method is available only for participants who joined the conference with the [spatialAudio](doc:js-client-sdk-model-joinoptions#spatialaudio) parameter enabled. Otherwise, SDK triggers [UnsupportedError](doc:js-client-sdk-model-unsupportederror).
     *
     * If not called, the SDK uses the default spatial environment, which consists of the following values:
     *
     * - `forward` = (0, 0, 1), where +Z axis is in front
     * - `up` = (0, 1, 0), where +Y axis is above
     * - `right` = (1, 0, 0), where +X axis is to the right
     * - `scale` = (1, 1, 1), where one unit on any axis is 1 meter
     *
     * The default spatial environment is presented in the following diagram:
     *
     * <--A graphic placeholder-->
     *
     * If sending the updated positions to the server fails, the SDK generates the ConferenceService event error that includes [SpatialAudioError](doc:js-client-sdk-model-spatialaudioerror).
     *
     * @param scale - The application's distance units or scale in application units per one meter. The value must be greater than 0. Otherwise, SDK emits [ParameterError](doc:js-client-sdk-model-parametererror).
     * @param forward - A vector describing the direction the application considers as forward. The value must be orthogonal to up and right. Otherwise, SDK emits [ParameterError](doc:js-client-sdk-model-parametererror).
     * @param up - A vector describing the direction the application considers as up. Must be orthogonal to forward and right. Otherwise, SDK emits [ParameterError](doc:js-client-sdk-model-parametererror).
     * @param right - A vector describing the direction the application considers as right. Must be orthogonal to forward and up. Otherwise, SDK emits [ParameterError](doc:js-client-sdk-model-parametererror).
     */
    setSpatialEnvironment(scale, forward, up, right) {
        if (!__classPrivateFieldGet(this, _conference) || !__classPrivateFieldGet(this, _conference).params.dolbyVoice || !__classPrivateFieldGet(this, _spatialAudioManager)) {
            throw new Exceptions_1.UnsupportedError();
        }
        __classPrivateFieldGet(this, _spatialAudioManager).setEnvironment(SpatialAudio_1.SpatialEnvironment.fromData(scale, forward, up, right));
    }
    /* istanbul ignore next */
    qualityIndicators(stats) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const indicators = new Map();
            const dolbyVoice = (_a = __classPrivateFieldGet(this, _conference).params) === null || _a === void 0 ? void 0 : _a.dolbyVoice;
            if (dolbyVoice) {
                this.participants.forEach((participant, key) => {
                    if (participant.status == Participant_1.ParticipantStatus.CONNECTED) {
                        let videoValue = -1;
                        stats.forEach((stat, key) => {
                            if (key === participant.id) {
                                const scores = stat.filter((s) => s.id === 'Scores');
                                if (scores.length > 0) {
                                    videoValue = scores[0].video;
                                }
                            }
                        });
                        indicators.set(key, { audio: participant.audioQuality ? participant.audioQuality : -1, video: videoValue });
                    }
                });
            }
            else {
                stats.forEach((stat, key) => {
                    const scores = stat.filter((s) => s.id === 'Scores');
                    if (scores.length > 0) {
                        indicators.set(key, { audio: scores[0].audio, video: scores[0].video });
                    }
                });
            }
            this.emit(ConferenceServiceEvents.QualityIndicators, indicators);
        });
    }
    onConferenceCreated() {
        this.emit(ConferenceServiceEvents.Created);
    }
    onConferenceJoined(e) {
        this._conferenceId = e.conferenceId;
        // Starting quality indicators
        __classPrivateFieldSet(this, _indicatorsInterval, setInterval(() => __awaiter(this, void 0, void 0, function* () {
            const stats = yield this.localStats();
            this.qualityIndicators(stats);
        }), INDICATORS_INTERVAL));
        this.emit(ConferenceServiceEvents.Joined);
    }
    onConferenceLeft(e) {
        this._conferenceId = null;
        if (__classPrivateFieldGet(this, _indicatorsInterval)) {
            clearInterval(__classPrivateFieldGet(this, _indicatorsInterval));
            __classPrivateFieldSet(this, _indicatorsInterval, null);
        }
        this.emit(ConferenceServiceEvents.Left);
    }
    onConferenceEnded(e) {
        this.emit(ConferenceServiceEvents.Ended);
    }
    onConferenceDestroyed(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (e.conferenceId === this._conferenceId) {
                yield this.leave();
                this.emit(ConferenceServiceEvents.Ended, e);
            }
        });
    }
    onConferenceStats(e) {
        this.emit(ConferenceServiceEvents.Stats, e);
    }
    onConferenceGlobalError(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.current && this.current.id) {
                ConferenceUtils_1.default.reportError(e, this.current.id);
                if (e.error instanceof Exceptions_1.DvcError) {
                    yield this.leave();
                }
            }
            this.emit(ConferenceServiceEvents.Error, e.error);
        });
    }
    onOfferCreated(e) {
        __classPrivateFieldGet(this, _manager).setRemoteOffer(e);
    }
    onActiveSpeakerChange(e) {
        this.participants.forEach((value, key) => {
            value.active = !!e.speakers.includes(value.id);
        });
    }
    onVideoForwardedChanged(e) {
        const filteredParticipants = new Map([...this.participants].filter(([_, v]) => ((v.status === Participant_1.ParticipantStatus.CONNECTED || v.status === Participant_1.ParticipantStatus.CONNECTING) && v.type === 'user') || v.type === 'robot'));
        // const backUp = new Map(this.#manager.forwardedParticipants);
        __classPrivateFieldGet(this, _manager).forwardedParticipants.clear();
        for (let [id, participant] of filteredParticipants) {
            if (participant.id === __classPrivateFieldGet(this, _session).participant.id)
                continue;
            const included = e.videoForwardedId.includes(id);
            if (included) {
                __classPrivateFieldGet(this, _manager).forwardedParticipants.set(id, participant);
            }
        }
        const toBeRemovedFromForwardedIds = Array.from(filteredParticipants.keys()).filter((participantId) => !e.videoForwardedId.includes(participantId) && participantId !== __classPrivateFieldGet(this, _session).participant.id);
        const toBeAddedTForwardedIds = Array.from(filteredParticipants.keys()).filter((participantId) => e.videoForwardedId.includes(participantId) && participantId !== __classPrivateFieldGet(this, _session).participant.id);
        // remove video tracks from stream and cached them
        toBeRemovedFromForwardedIds.forEach((id) => {
            var _a;
            const participant = this.participants.get(id);
            // get participant stream (only video stream)
            const streams = participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.Camera);
            // no video stream included
            if (streams.length <= 0)
                return;
            // update cache for current participant with current video
            const tracks = streams[0].getVideoTracks();
            if (tracks && tracks.length > 0) {
                __classPrivateFieldGet(this, _cachedTracks).set(participant.id, tracks);
                tracks.forEach((track) => streams[0].removeTrack(track));
            }
            this.emit(ConferenceServiceEvents.StreamUpdated, participant, ((_a = this.current.params) === null || _a === void 0 ? void 0 : _a.dolbyVoice) && participant.audio ? new MediaStream_1.DvcsMediaStream(streams[0]) : streams[0]);
        });
        // added cached video tracks to participant stream
        toBeAddedTForwardedIds.forEach((id) => {
            var _a;
            const participant = this.participants.get(id);
            const streams = participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.Camera);
            if (streams.length <= 0)
                return;
            //get cached tracks - may create helper function
            const tracks = __classPrivateFieldGet(this, _cachedTracks).get(id);
            if (tracks && tracks.length > 0)
                tracks.forEach((track) => streams[0].addTrack(track));
            // this.removeParticipantVideoTracksFromCache(participant, this.#cachedTracks);
            if (__classPrivateFieldGet(this, _cachedTracks).has(participant.id)) {
                __classPrivateFieldGet(this, _cachedTracks).delete(participant.id);
            }
            this.emit(ConferenceServiceEvents.StreamUpdated, participant, ((_a = this.current.params) === null || _a === void 0 ? void 0 : _a.dolbyVoice) && participant.audio ? new MediaStream_1.DvcsMediaStream(streams[0]) : streams[0]);
        });
    }
    onDvcsMetric(e) {
        if (e.name === 'GetLevel') {
            const dB = e.value;
            const alpha = 2;
            const vmin = -40;
            const vmax = -15;
            const level = Math.exp(alpha * ((dB - vmin) / (vmax - vmin) - 1));
            // const level = Math.pow(10, dB / 20);
            const participant = this.participants.get(e.userId);
            participant.level = dB == -90 ? 0 : level;
        }
        else if (e.name === 'GetQuality') {
            if (e.value > 0) {
                const participant = this.participants.get(e.userId);
                if (participant) {
                    participant.audioQuality = e.value;
                }
            }
        }
    }
    /**
     *
     * @ignore
     */
    onUpdateToken(e) {
        VoxeetApi_1.default.setConferenceTokens(e.conferenceId, e.conferenceAccessToken);
        VoxeetApi_1.default.currentConferenceToken = e.conferenceAccessToken;
        this.updatePermissionsFromToken(e.conferenceAccessToken);
    }
    /**
     * Updates the participant's permissions by decoding the conference access token.
     * @ignore
     */
    updatePermissionsFromToken(token) {
        // decode conference token
        let newPermissions = this.getPermissionsFromToken(token);
        const checkPermissions = (permissions) => permissions.size === newPermissions.size && [...permissions].every((permission) => newPermissions.has(permission));
        // current conference not set
        if (!this.current)
            return;
        // permissions not set for current conference.
        if (!this.current.permissions || !checkPermissions(this.current.permissions)) {
            const media = __classPrivateFieldGet(this, _session).participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.Camera);
            const screenshareMedia = __classPrivateFieldGet(this, _session).participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.ScreenShare);
            if (media.length > 0 && media[0].getVideoTracks().length > 0 && !newPermissions.has(Conference_1.ConferencePermission.SendVideo)) {
                __classPrivateFieldGet(this, _manager).stopVideoLocally(__classPrivateFieldGet(this, _session).participant.id);
            }
            if (screenshareMedia.length > 0 && !newPermissions.has(Conference_1.ConferencePermission.ShareScreen)) {
                __classPrivateFieldGet(this, _manager).stopScreenShareLocally();
            }
            if (media.length > 0 && media[0].getAudioTracks().length > 0) {
                if (this.current.permissions.has(Conference_1.ConferencePermission.SendAudio) && !newPermissions.has(Conference_1.ConferencePermission.SendAudio)) {
                    __classPrivateFieldGet(this, _manager).rtc.stopAudioForPeer(__classPrivateFieldGet(this, _session).participant.id);
                }
            }
            this.current.permissions = new Set(newPermissions);
            this.emit(ConferenceServiceEvents.PermissionsUpdated, this.current.permissions);
        }
    }
    getPermissionsFromToken(token) {
        let decoded = jwt_decode_1.default(token);
        return new Set(decoded.authorities);
    }
    onParticipantAdded(e) {
        var _a;
        let participant = this.participants.get(e.userId);
        if (!participant || participant.id === __classPrivateFieldGet(this, _session).participant.id) {
            // Fix for participantAdded not received in the right order
            participant = __classPrivateFieldGet(this, _manager).addParticipant(e);
            this.emit(ConferenceServiceEvents.ParticipantAdded, participant);
            debug('participant added: ', participant);
            // TODO(dvwc): handle wasm case as well
            const dolbyVoice = (_a = this.current.params) === null || _a === void 0 ? void 0 : _a.dolbyVoice;
            if (dolbyVoice) {
                const audioTransmitting = participant.audioTransmitting;
                const videos = participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.Camera);
                const videoTracks = videos.length > 0 && videos[0].getVideoTracks();
                const videoTrack = videoTracks.length > 0 && videoTracks[0];
                if (audioTransmitting && !videoTrack && !__classPrivateFieldGet(this, _cachedTracks).get(participant.id)) {
                    this.emit(ConferenceServiceEvents.StreamAdded, participant, new MediaStream_1.DvcsMediaStream(new MediaStream()));
                }
            }
        }
        else {
            participant = __classPrivateFieldGet(this, _manager).updateParticipant(e);
            this.emit(ConferenceServiceEvents.ParticipantUpdated, participant);
            debug('participant updated: ', participant);
        }
    }
    clearStream(participant, stream) {
        // get participant stream (only video stream)
        const streams = participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.Camera);
        // no video stream included
        if (streams.length <= 0)
            return stream;
        // update cache for current participant with current video
        const tracks = streams[0].getVideoTracks();
        if (tracks && tracks.length > 0) {
            __classPrivateFieldGet(this, _cachedTracks).set(participant.id, tracks);
            tracks.forEach((track) => streams[0].removeTrack(track));
        }
        return streams[0];
    }
    onParticipantUpdated(e) {
        const previousAudioTransmitting = __classPrivateFieldGet(this, _manager).participants.get(e.userId) && __classPrivateFieldGet(this, _manager).participants.get(e.userId).audioTransmitting;
        const participant = __classPrivateFieldGet(this, _manager).updateParticipant(e);
        debug('participant updated: ', participant);
        if (participant) {
            this.emit(ConferenceServiceEvents.ParticipantUpdated, participant);
            this.onParticipantUpdatedHandleStreams(participant, previousAudioTransmitting, participant.audioTransmitting);
        }
    }
    onParticipantUpdatedHandleStreams(participant, previousAudioTransmitting, audioTransmitting) {
        var _a;
        // check if local
        if (participant.id === __classPrivateFieldGet(this, _session).participant.id)
            return;
        // TODO: use find instead of filter
        const videos = participant.streams.filter((stream) => stream.type === MediaStream_1.MediaStreamType.Camera);
        const videoTracks = videos.length > 0 && videos[0].getVideoTracks();
        const videoTrack = videoTracks.length > 0 && videoTracks[0];
        const dolbyVoice = (_a = this.current.params) === null || _a === void 0 ? void 0 : _a.dolbyVoice;
        if (dolbyVoice) {
            if (audioTransmitting) {
                if (!previousAudioTransmitting) {
                    if (videoTrack || __classPrivateFieldGet(this, _cachedTracks).get(participant.id)) {
                        this.emit(ConferenceServiceEvents.StreamUpdated, participant, new MediaStream_1.DvcsMediaStream(videos[0] ? videos[0] : new MediaStream()));
                    }
                    else {
                        const fakeAudioStream = new MediaStream_1.DvcsMediaStream(new MediaStream());
                        participant.streams.push(fakeAudioStream);
                        __classPrivateFieldGet(this, _notificationSentForParticipantsIds).push(participant.id);
                        this.emit(ConferenceServiceEvents.StreamAdded, participant, fakeAudioStream);
                    }
                }
            }
            else {
                // fake local leave and normal case
                if (previousAudioTransmitting /*&& !mediaVideoTrack*/) {
                    if (!videoTrack && !__classPrivateFieldGet(this, _cachedTracks).get(participant.id)) {
                        participant.streams = participant.streams.filter((s) => !(s.getAudioTracks().length && s.getAudioTracks()[0].id === 'fakeAudioTrack'));
                        this.emit(ConferenceServiceEvents.StreamRemoved, participant, new MediaStream_1.DvcsMediaStream(new MediaStream()));
                    }
                    else {
                        this.emit(ConferenceServiceEvents.StreamUpdated, participant, videos[0]);
                    }
                }
            }
        }
    }
    onParticipantKicked(e) {
        e.status = 'KICKED';
        const participant = __classPrivateFieldGet(this, _manager).updateParticipant(e);
        if (!participant)
            return;
        this.emit(ConferenceServiceEvents.ParticipantUpdated, participant);
        __classPrivateFieldGet(this, _manager).onKicked();
        __classPrivateFieldGet(this, _manager).clear();
        __classPrivateFieldSet(this, _conference, null);
    }
    onParticipantSwitched(e) {
        __classPrivateFieldGet(this, _manager).participantSwitched(e);
    }
    onOwnParticipantSwitched(e) {
        this.emit(ConferenceServiceEvents.Switched);
        this.leave({ leaveRoom: false });
    }
    /**
     * @ignore
     */
    onAutoplayBlocked() {
        this.emit(ConferenceServiceEvents.AutoplayBlocked);
    }
    /**
     * @ignore
     * @param peerId
     * @param stream
     */
    onStreamAdded(peerId, stream) {
        setTimeout(() => {
            var _a;
            let participant = this.participants.get(peerId);
            if (!stream || !participant) {
                const regex = /^0{8}-0{4}-0{4}-0{4}-0{12}$/gm;
                const fake = regex.test(peerId);
                if (!fake)
                    console.warn(`Unable to find participant: ${peerId}`);
                return;
            }
            participant.streams.push(stream);
            participant.streams = participant.streams.filter((s) => !(s.getAudioTracks().length && s.getAudioTracks()[0].id === 'fakeAudioTrack'));
            const dolbyVoice = (_a = this.current.params) === null || _a === void 0 ? void 0 : _a.dolbyVoice;
            if (dolbyVoice) {
                if (participant.id === __classPrivateFieldGet(this, _session).participant.id) {
                    this.emit(ConferenceServiceEvents.StreamAdded, participant, stream);
                    return;
                }
                if (stream.type === MediaStream_1.MediaStreamType.ScreenShare) {
                    this.emit(ConferenceServiceEvents.StreamAdded, participant, stream);
                    return;
                }
                const audioTransmitting = participant.audioTransmitting;
                const included = Array.from(__classPrivateFieldGet(this, _manager).forwardedParticipants.keys()).includes(participant.id);
                const st = included ? stream : this.clearStream(participant, stream);
                if (!__classPrivateFieldGet(this, _notificationSentForParticipantsIds).includes(participant.id)) {
                    __classPrivateFieldGet(this, _notificationSentForParticipantsIds).push(participant.id);
                    if (audioTransmitting) {
                        this.emit(ConferenceServiceEvents.StreamAdded, participant, new MediaStream_1.DvcsMediaStream(st));
                    }
                    else {
                        this.emit(ConferenceServiceEvents.StreamAdded, participant, st);
                    }
                }
                else {
                    if (audioTransmitting) {
                        this.emit(ConferenceServiceEvents.StreamUpdated, participant, new MediaStream_1.DvcsMediaStream(st));
                    }
                    else {
                        this.emit(ConferenceServiceEvents.StreamUpdated, participant, st);
                    }
                }
            }
            else {
                if (participant.id === __classPrivateFieldGet(this, _session).participant.id) {
                    this.emit(ConferenceServiceEvents.StreamAdded, participant, stream);
                    return;
                }
                if (stream.type === MediaStream_1.MediaStreamType.ScreenShare) {
                    this.emit(ConferenceServiceEvents.StreamAdded, participant, stream);
                    return;
                }
                const included = Array.from(__classPrivateFieldGet(this, _manager).forwardedParticipants.keys()).includes(participant.id);
                const st = included ? stream : this.clearStream(participant, stream);
                this.emit(ConferenceServiceEvents.StreamAdded, participant, st);
            }
        }, 0);
    }
    /**
     * @ignore
     * @param peerId
     * @param stream
     */
    onStreamUpdated(peerId, stream) {
        setTimeout(() => {
            let participant = this.participants.get(peerId);
            if (participant) {
                participant.streams = participant.streams.filter((s) => s.id !== stream.id);
                participant.streams = participant.streams.filter((s) => !(s.getAudioTracks().length && s.getAudioTracks()[0].id === 'fakeAudioTrack'));
                participant.streams.push(stream);
                if (__classPrivateFieldGet(this, _cachedTracks).has(participant.id)) {
                    const videoTracks = stream.getVideoTracks();
                    videoTracks.forEach((track) => stream.removeTrack(track));
                }
                this.emit(ConferenceServiceEvents.StreamUpdated, participant, stream);
            }
            else {
                const regex = /^0{8}-0{4}-0{4}-0{4}-0{12}$/gm;
                const fake = regex.test(peerId);
                if (!fake) {
                    console.warn(`Unable to find participant: ${peerId}`);
                }
            }
        }, 0);
    }
    /**
     * @ignore
     * @param peerId
     * @param stream
     */
    onStreamRemoved(peerId, stream) {
        var _a;
        let participant = this.participants.get(peerId);
        if (!participant) {
            const regex = /^0{8}-0{4}-0{4}-0{4}-0{12}$/gm;
            const fake = regex.test(peerId);
            if (!fake)
                console.warn(`Unable to find participant: ${peerId}`);
            return;
        }
        // update participant's streams
        participant.streams = participant.streams.filter((s) => s.id !== stream.id);
        const dolbyVoice = (_a = this.current.params) === null || _a === void 0 ? void 0 : _a.dolbyVoice;
        if (!dolbyVoice) {
            setTimeout(() => {
                //this.removeParticipantVideoTracksFromCache(participant, this.#cachedTracks);
                this.emit(ConferenceServiceEvents.StreamRemoved, participant, stream);
            }, 0);
            return;
        }
        const video = stream && stream.getVideoTracks()[0];
        const isScreenShare = stream.type === MediaStream_1.MediaStreamType.ScreenShare;
        if (participant.id === __classPrivateFieldGet(this, _session).participant.id) {
            this.emit(ConferenceServiceEvents.StreamRemoved, participant, stream);
            return;
        }
        // remote participant or participant already left
        if (participant.status === Participant_1.ParticipantStatus.LEFT || __classPrivateFieldGet(this, _session).participant.status === Participant_1.ParticipantStatus.LEFT) {
            this.emit(ConferenceServiceEvents.StreamRemoved, participant, stream);
            return;
        }
        setTimeout(() => {
            if (dolbyVoice) {
                if (!participant.audioTransmitting) {
                    this.emit(ConferenceServiceEvents.StreamRemoved, participant, stream);
                    const index = __classPrivateFieldGet(this, _notificationSentForParticipantsIds).indexOf(participant.id);
                    if (index > -1) {
                        __classPrivateFieldGet(this, _notificationSentForParticipantsIds).splice(index, 1);
                    }
                    return;
                }
                if (!video) {
                    if (isScreenShare) {
                        // if this is a screen share, removes it
                        this.emit(ConferenceServiceEvents.StreamRemoved, participant, stream);
                        const index = __classPrivateFieldGet(this, _notificationSentForParticipantsIds).indexOf(participant.id);
                        if (index > -1) {
                            __classPrivateFieldGet(this, _notificationSentForParticipantsIds).splice(index, 1);
                        }
                    }
                    else {
                        // in this case : participant stopped his video => updates the stream
                        // add fake audio stream
                        const updatedStream = new MediaStream_1.DvcsMediaStream(stream);
                        participant.streams.push(updatedStream);
                        this.emit(ConferenceServiceEvents.StreamUpdated, participant, updatedStream);
                    }
                }
                else {
                    //this.removeParticipantVideoTracksFromCache(participant, this.#cachedTracks);
                    this.emit(ConferenceServiceEvents.StreamRemoved, participant, stream);
                    const index = __classPrivateFieldGet(this, _notificationSentForParticipantsIds).indexOf(participant.id);
                    if (index > -1) {
                        __classPrivateFieldGet(this, _notificationSentForParticipantsIds).splice(index, 1);
                    }
                }
            }
        }, 0);
    }
    /**
     * @ignore
     */
    get peerConnectionStatus() {
        return __classPrivateFieldGet(this, _manager).getPeerConnectionStatus();
    }
    /**
     * Provides a list of conference participants.
     */
    get participants() {
        return __classPrivateFieldGet(this, _manager) ? __classPrivateFieldGet(this, _manager).participants : new Map();
    }
    /**
     * Provides the number of video streams that are transmitted to the local user.
     */
    get maxVideoForwarding() {
        return __classPrivateFieldGet(this, _manager) ? __classPrivateFieldGet(this, _manager).maxVideoForwarding : undefined;
    }
    /**
     * Returns information about the current conference. Use this accessor if you wish to receive information that is available in the [Conference](doc:js-client-sdk-model-conference) object, such as the conference [alias](doc:js-client-sdk-model-conference#alias), [ID](doc:js-client-sdk-model-conference#id), information if the conference [is new](doc:js-client-sdk-model-conference#isnew), conference [parameters](doc:js-client-sdk-model-conference#params), local participant's conference [permissions](doc:js-client-sdk-model-conference#permissions), conference [PIN code](doc:js-client-sdk-model-conference#pincode), or conference [status](doc:js-client-sdk-model-conference#status). For example, use the following code to ask about the local participant's conference permissions:
     *
     * ```JavaScript
     * VoxeetSDK.conference.current.permissions
     * ```
     */
    get current() {
        return __classPrivateFieldGet(this, _conference);
    }
    /**
     * @ignore
     */
    get manager() {
        return __classPrivateFieldGet(this, _manager);
    }
    get leaveConferenceOnBeforeUnload() {
        return __classPrivateFieldGet(this, _leaveConferenceOnBeforeUnload);
    }
};
_manager = new WeakMap(), _session = new WeakMap(), _conference = new WeakMap(), _notificationSentForParticipantsIds = new WeakMap(), _indicatorsInterval = new WeakMap(), _isJoining = new WeakMap(), _cachedTracks = new WeakMap(), _leaveConferenceOnBeforeUnload = new WeakMap(), _spatialAudioManager = new WeakMap();
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "playBlockedAudio", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "mute", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "toggleMute", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "isMuted", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "audioLevel", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "isSpeaking", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "startStream", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "stopStream", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "startVideo", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "stopVideo", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "videoForwarding", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "audioProcessing", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "startAudio", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "stopAudio", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "startScreenShare", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "stopScreenShare", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "localStats", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "simulcast", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "kick", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "createStateDump", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "getStateDumpConfiguration", null);
__decorate([
    Service_1.ConferenceNotNull()
], ConferenceService.prototype, "configureStateDump", null);
ConferenceService = __decorate([
    Service_1.Subscribe([
        events_1.EventType.ConferenceGlobalError,
        events_1.EventType.OfferCreated,
        events_1.EventType.ParticipantAdded,
        events_1.EventType.ParticipantUpdated,
        events_1.EventType.ParticipantSwitched,
        events_1.EventType.OwnParticipantSwitched,
        events_1.EventType.ConferenceStats,
        events_1.EventType.ConferenceDestroyed,
        events_1.EventType.DvcsMetric,
        events_1.EventType.ActiveSpeakerChange,
        events_1.EventType.VideoForwardedChanged,
        events_1.EventType.UpdateToken,
        events_1.EventType.ParticipantKicked,
    ])
], ConferenceService);
exports.ConferenceService = ConferenceService;
